export const frontmatter = {
    "draft": true,
    "title": "Roles",
    "description": "Role and permission management in OnnIA.",
    "sidebar_label": "Roles",
    "sidebar_group": "reference",
    "sidebar_order": 2
}

export const toc = []